import { Expose } from "class-transformer";

export class CreateAntiFallPpeTypeDto {
  @Expose()
  name: string;
}
